export default __webpack_public_path__ + "static/media/02.25a231d8.jpg";